import {defineStore} from "pinia";

interface LoginParams {
  email: string;
  password: string
}

interface BaseLoginResult  {
  status: boolean;
}

interface LoginWithError extends BaseLoginResult {
  status: false;
  errorCode: number;
}

interface LoginSuccess extends BaseLoginResult {
  status: true;
}

type LoginResult = LoginSuccess | LoginWithError;

export const useAuthStore = defineStore('auth-store', () => {
  const {login: loginRequest} = useStrapiAuth();

  const accessToken = useStrapiToken();  
  const user = useStrapiUser()

  const login = async ({email, password}: LoginParams): Promise<LoginResult> => {
    try {
      const res = await loginRequest({
        identifier: email.replace(/[^\x20-\x7E]/g, ''),
        password: password.replace(/[^\x20-\x7E]/g, ''),
      });
      accessToken.value = res.jwt
      localStorage.setItem('accessToken', accessToken.value)
      return {status: true}
    } catch (e) {
      if ((typeof e === 'object') && e && ('error' in e) && (typeof e.error === 'object') && e.error && ('status' in e.error)) {
        return {status: false, errorCode: e.error.status as number}
      }
      return {status: false, errorCode: 500}
    }
  }

  const logout = async () =>{
    localStorage.clear();
    accessToken.value = null;
    window.location.reload()
  }

  return {login, accessToken, logout, user}
})
